import React from 'react';

const MeasurementsHeader = () => {
    return (
        <div>
            <h1>Body Measurements</h1>
        </div>
    );
};

export default MeasurementsHeader;
